import React from 'react';
import { useRouter } from 'next/navigation';
import CitySearch from '../search-area/CitySearch';
import NavigationTabs from '@/components/navigation/NavigationTabs';
import {
  ACTIVE_TABS,
  NAV_BOTTOM_SCROLL_OFFSET,
  NAV_TOP_SCROLL_OFFSET,
} from '@/constants/city';
import {
  CascadeOption,
  Option,
} from '@/components/form/cascade-select/CascadeSelect';
import { CityContext } from '@/context/create-context';

const Tabs = (props: { existCities: CascadeOption[] }) => {
  const { existCities } = props;
  const { id: cityId, name, pinyin } = React.useContext(CityContext);
  const [selectedTab, setSelectedTab] = React.useState(ACTIVE_TABS[0].en);
  const observerRef = React.useRef<HTMLDivElement | null>(null);
  const router = useRouter();

  const handleSearch = (value: Option) => {
    const { id, pinyin } = value;
    if (!pinyin || id === cityId) return;
    router.push(`/${pinyin}/`);
  };

  return (
    <>
      <div ref={observerRef} />
      <div className="flex gap-x-10 sticky justify-between py-2 items-center z-[1101] bg-white top-0 mx-[calc(50%-50vw)] px-[calc(50vw-50%)] supports-[width:100dvw]:mx-[calc(50%-50dvw)] supports-[width:100dvw]:px-[calc(50dvw-50%)]">
        <NavigationTabs
          setSelectedTab={setSelectedTab}
          selectedTab={selectedTab}
          activeTabs={ACTIVE_TABS}
          sticky={false}
          initObserverRef={observerRef}
          topOffset={NAV_TOP_SCROLL_OFFSET}
          bottomOffset={NAV_BOTTOM_SCROLL_OFFSET}
          isFullScreen={true}
          keepActiveTab={true}
        />
        <CitySearch
          existCities={existCities}
          cityValue={{ id: cityId, name, pinyin }}
          onSearch={handleSearch}
        />
      </div>
    </>
  );
};

export default Tabs;
